// state
const state = () => ({
  impostos: [],
  perguntas: [],
  possiveisAbas: [],
  possiveisAbasCenario: []
});

// getters
const getters = {
  getImpostos: state => {
    return state.impostos;
  },
  getPerguntas: state => {
    return state.perguntas;
  },
  getPossiveisAbas: state => {
    return state.possiveisAbas;
  },
  getPossiveisAbasCenario: state => id => {
    let abas = state.possiveisAbasCenario.find(p => p.id == id);
    return abas ? abas.abas : null;
  },
  getPossiveisAbasTodas: state => {
    return state.possiveisAbasCenario;
  },
  getPossiveisAbasUnidas: state => {
    let abasUnidas = [];
    state.possiveisAbasCenario.forEach(p => {
      abasUnidas = [...new Set([...abasUnidas, ...p.abas])];
    });
    return abasUnidas;
  }
};

// mutations
const mutations = {
  SET_IMPOSTOS(state, value) {
    state.impostos = value;
  },
  SET_PERGUNTAS(state, value) {
    state.perguntas = value;
  },
  SET_POSSIVEIS_ABAS(state, value) {
    state.possiveisAbas = value;
  },
  SET_POSSIVEIS_ABAS_CENARIO(state, [value, id]) {
    const aba = state.possiveisAbasCenario.find(p => p.id === id);
    if (aba) {
      aba.abas = value;
    } else {
      state.possiveisAbasCenario.push({ id, abas: value });
    }
  },
  SET_LIMPA_POSSIVEIS_ABAS(state) {
    state.possiveisAbasCenario = [];
  }
};

// actions
const actions = {
  /**
   * Deve ser chamado quando clicar no botão Resultado
   * @param {String} cenario
   */
  setImpostos({ commit, state }, { id, imposto, fundoICMS }) {
    let newId = typeof id != "number" ? id.replace("Cenario", "") : id;
    newId = parseInt(newId);

    var impostos = state.impostos;

    impostos[newId] = imposto;

    if (!impostos[newId]) return;

    var data = new Date();
    impostos[newId]["time"] = data.toLocaleTimeString();

    commit("SET_IMPOSTOS", impostos);
  },
  removeImposto({ commit, state }, id) {},
  setPerguntaSelecionada({ commit, state }, { id, classe, pergunta }) {
    if (!id || !classe) {
      return;
    }

    let perguntas = state.perguntas;

    if (!perguntas[id]) {
      perguntas[id] = [];
    }

    if (!perguntas[id][classe]) {
      perguntas[id][classe] = null;
    }

    if (pergunta) {
      pergunta.blIcmsSelected = true;
    }

    perguntas[id][classe] = pergunta;

    commit("SET_PERGUNTAS", perguntas);
  },
  returnPerguntaSelecionada({ commit, state }, { id, classe }) {
    let perguntas = state.perguntas;

    if (!perguntas[id]) {
      return false;
    }

    return perguntas[id][classe];
  },
  setPossiveisAbas({ commit }, abas) {
    commit("SET_POSSIVEIS_ABAS", abas);
  },
  setPossiveisAbasCenario({ commit }, [abas, id]) {
    commit("SET_POSSIVEIS_ABAS_CENARIO", [abas, id]);
  },
  setLimpaPossiveisAbas({ commit }) {
    commit("SET_LIMPA_POSSIVEIS_ABAS");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
